// export default {
//   baseUrl: "http://sheet.test",
//   sheetsEndpoint: "/",
//   setPreview: ""
// }

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

let isLocal = window.location.host.includes('localhost');
let pluginSetHash = getCookie("PluginSetPreview");

// try {
//   if (pluginSetHash) pluginSetHash = decodeURI(pluginSetHash);
//   if (isLocal) pluginSetHash = "JDJ5JDEwJFNVdk9LTGtoMUM4UXZ0U0JnVWUxZi55dnJLVk5RaU9NZGtMcEFmeFZ1UEVSNHBnY3dGaDcu";
//   else pluginSetHash = JSON.parse(pluginSetHash).hash;
// } catch (error) {
//   console.log("Hash could not be parsed", error);
// }

export default {
  baseUrl: "https://www.geaplan-dachbahn.de",
  sheetsEndpoint: "/dachbahn-konfigurator/sheet-data",
  itemEndpoint: "/dachbahn-konfigurator/item",
  itemsByPrefixEndpoint: "/dachbahn-konfigurator/items-by-prefix",
  imageEndpoint: "/dachbahn-konfigurator/item-images",
  setPreview: pluginSetHash,
};
